import { useSessionStorage } from '@mantine/hooks';

export const OMNI_SEARCH_STORAGE_KEY = 'omniSearchInputText';

/**
 * Retrieve the omni-search value from session storage.
 * @returns string
 */
export const getOmniSearchValue = () => {
  const searchValue = JSON.parse(
    window?.sessionStorage?.getItem(OMNI_SEARCH_STORAGE_KEY) || '""',
  );
  const sanitizedValue = searchValue?.replace(/^\//, '')?.trim();
  return sanitizedValue || '';
};

export function useOmniSearchInputText(defaultValue = '') {
  const [value, setValue] = useSessionStorage<string>({
    key: OMNI_SEARCH_STORAGE_KEY,
    defaultValue: defaultValue,
  });

  return {
    value,
    setValue,
    getOmniSearchValue,
  };
}
